import { render, staticRenderFns } from "./SessionResultSent.vue?vue&type=template&id=186970d4"
import script from "./SessionResultSent.vue?vue&type=script&lang=js"
export * from "./SessionResultSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports